import Validator from './validator'

const validator = new Validator()

export { Validator, validator }

export * from './types'

export default validator
